// extracted by mini-css-extract-plugin
export default {"container":"oM-z","error":"pM-z","disabled":"qM-z","submit":"rM-z","option":"sM-z","success":"tM-z","failure":"uM-z"};